package co.uk.sacursoftware.ssinventory.util

import kotlinx.datetime.*
import kotlin.js.Date

actual fun getCurrentLocalDate(): LocalDate {
    val d = Date()
    return LocalDate(d.getFullYear(), d.getMonth() + 1, d.getDate())
}

actual fun getCurrentEpochMillis(): Long {
    return Date.now().toLong()
}
